import { render, staticRenderFns } from "./BilalCaseStudy.vue?vue&type=template&id=02fdf8c4&scoped=true"
import script from "./BilalCaseStudy.vue?vue&type=script&lang=js"
export * from "./BilalCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./BilalCaseStudy.vue?vue&type=style&index=0&id=02fdf8c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fdf8c4",
  null
  
)

export default component.exports